/* eslint-disable no-unused-vars */
import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Box,
  Dialog,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Currency from 'assets/icons/currency.svg';
import Goal from 'assets/icons/goal.svg';
import StatusLiveIcon from 'assets/icons/status-live.svg';
import ActivityContainer from 'component/ActivityContainer/ActivityContainer';
import BuyerRegistration from 'component/BuyerRegistration/BuyerRegistration';
import ForecastContainer from 'component/ForecastContainer/ForecastContainer';
import LiveOfferStatus from 'component/LiveOfferStatus/LiveOfferStatus';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import LocationDetails from 'component/LocationDetails/LocationDetails';
import MessagingContainer from 'component/MessagingContainer/MessagingContainer';
import Offeractivity from 'component/Offeractivity/Offeractivity';
import StatusCardContainer from 'component/StatusCardContainer/StatusCardContainer';
import VendorStatusContainer from 'component/VendorStatusContainer/VendorStatusContainer';
import {
  AGENT_GETQUESTION,
  AGENT_SAVEQUESTION,
  API_URL,
  CONTRACT_FILE_UPLOAD,
  GET_PROPERTY_INDIVIDUAL,
  GET_SECTION_ORDER,
  OFFER_ACTIVITY,
  OFFER_ACTIVITY_VENDOR,
  STORE_SECTION_ORDER,
} from 'constant/app.config';
import Auction from 'modules/private/Auction/Auction';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
// import {  postApiCall } from "api/apiService";
// import { getApiCall } from "api/apiService";
import { useTheme } from '@emotion/react';
import { getApiCall, getForecastData, postApiCall } from 'api/apiService';
import { Pricebracket, Propertyworth } from 'component/Questionaire/Review';
import { useHistory } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { locationStyles, highStarStyle } from './ViewDashboardDetails.style';

import Loading from 'assets/images/loading.png';
import dayjs from 'dayjs';
import { datacontext } from 'modules/AppLayout/AppLayout';
import Moxochat from 'component/Moxochat/Moxochat';
import WinnerPopperComponent from 'component/BuyerRegistration/WinnerPopperComponent';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import IndexAgentBanners from 'component/BannerComponents/AgentBanners/IndexAgentBanners';
import AgentChat from 'component/Questionaire/AgentChat';
import ExchangeConfirmDialog from 'component/ExchangeSettlementPopups/Exchange_Confirm';
import ExchangeStatusDialog from 'component/ExchangeSettlementPopups/Exchange_Update';
import SettlementConfirm from 'component/ExchangeSettlementPopups/SettlementStatus_Confirm';
import SettlementStatusDialog from 'component/ExchangeSettlementPopups/SettlementStatus_Update';
import UpdateListingPopup from '../AgentDashboard/UpdateListing';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { propertyDetail } from 'component/Chart/ModelGraphExpand.style';
import NominateWinnerDialog from 'component/ExchangeSettlementPopups/FlowNominateWinner';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ShareWinnerDialog from './ShareWinnerPopup';
import DetailsPopup from 'component/VendorStatusContainer/DepositManager/StatusDetailsPopups/DetailsPopup';
import FinalContractUploadDialog from 'component/BuyerRegistration/components/FinalContractUploadDialog';
import PrepareContractSignDialog from 'component/BuyerRegistration/components/PrepareContractSignDialog';
import DepositManagerPopup from 'component/VendorStatusContainer/DepositManager/DepositManagerPopup';
import Requestdeposit from 'component/BuyerRegistration/components/RequestDepositPopup';
import DocumentHub from 'component/FileManager/DocumentHub';
import { useAgentBannerData } from 'Hooks/agent/useAgentBannerData';

export const HighStar = (props) => {
  return (
    <svg
      {...props}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 0L5.75152 2.99803L9 3.43769L6.47146 5.50106L7.28115 9L4.5 7.04803L1.71885 9L2.52848 5.50106L0 3.43769L3.24848 2.99803L4.5 0Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

export const TrophyIcon = ({ color }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5842 12.9359C13.9042 11.9239 15.8402 10.4279 15.8402 4.8399V4.3999H6.16016V4.8399C6.16016 10.4279 8.14016 11.9239 9.41616 12.9359C10.1642 13.5079 10.5602 13.8159 10.5602 14.5199V15.8399C9.85616 15.9279 9.15216 16.1919 8.88816 16.7199H7.92016C7.43616 16.7199 7.04016 17.1159 7.04016 17.5999H14.9602C14.9602 17.1159 14.5642 16.7199 14.0802 16.7199H13.1122C12.8482 16.1919 12.1882 15.9279 11.4402 15.8399V14.5199C11.4402 13.8159 11.7922 13.5079 12.5842 12.9359ZM11.0002 13.1559C10.7362 12.8039 10.3402 12.4959 9.98816 12.2319C8.80016 11.3079 7.17216 10.0759 7.08416 5.2799H15.0042C14.9162 10.0319 13.2882 11.3079 12.1002 12.2319C11.6602 12.5399 11.2642 12.8039 11.0002 13.1559Z"
        fill={color}
      />
      <path
        d="M8.27153 11.8798C8.22753 11.8798 3.51953 10.8678 3.51953 5.71979V5.27979H6.59953V6.15979H4.39953C4.66353 10.2078 8.40353 10.9998 8.44753 10.9998L8.27153 11.8798Z"
        fill={color}
      />
      <path
        d="M13.7268 11.8798L13.5508 10.9998C13.7268 10.9558 17.3348 10.1638 17.5988 6.15979H15.3988V5.27979H18.4788V5.71979C18.4788 10.8678 13.7708 11.8798 13.7268 11.8798Z"
        fill={color}
      />
    </svg>
  );
};
const BuyerhighestOffBadge = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_30764_192193)">
        <path
          d="M17.9487 14.7662L14.657 8.67878C14.9928 7.91659 15.1807 7.07425 15.1807 6.18803C15.1807 2.77253 12.4118 0.00390625 8.99655 0.00390625C5.58049 0.00390625 2.81186 2.77281 2.81186 6.18803C2.81186 7.09562 3.00902 7.95681 3.36002 8.73306L0.0536429 14.7633C-0.0529685 14.9571 -0.0352497 15.1962 0.0980628 15.3731C0.231657 15.5495 0.457219 15.6324 0.672639 15.5818L3.49611 14.9341L4.46248 17.6256C4.53786 17.8349 4.72883 17.98 4.95017 17.9963C4.96453 17.9975 4.9783 17.998 4.9918 17.998C5.09351 17.998 5.1933 17.9704 5.28057 17.9181C5.36783 17.8659 5.4393 17.7909 5.48736 17.7013L8.36483 12.3404C8.57462 12.3617 8.78536 12.3723 8.99623 12.3722C9.1917 12.3722 9.38462 12.3621 9.57531 12.3441L12.5152 17.7055C12.5672 17.8006 12.6456 17.8786 12.7409 17.9301C12.8362 17.9816 12.9444 18.0045 13.0524 17.996C13.2732 17.9783 13.4633 17.8335 13.5381 17.6254L14.5045 14.9338L17.3279 15.5815C17.5445 15.6338 17.7678 15.5497 17.9014 15.3739C18.0356 15.1984 18.0536 14.9605 17.9487 14.7662H17.9487ZM5.09414 16.056L4.38648 14.0844C4.28972 13.8164 4.00906 13.6603 3.73116 13.7264L1.64288 14.2053L4.02314 9.86395C4.80698 10.9229 5.92073 11.7216 7.21251 12.1103L5.09414 16.056ZM3.94184 6.18801C3.94184 3.40111 6.20957 1.13367 8.99674 1.13367C11.7836 1.13367 14.0511 3.40111 14.0511 6.18801C14.0511 8.97492 11.7836 11.2429 8.99674 11.2429C6.20927 11.2429 3.94184 8.97492 3.94184 6.18801ZM14.2693 13.7263C13.9903 13.6605 13.7108 13.8163 13.614 14.0844L12.9016 16.0703L10.7368 12.1229C12.0629 11.7345 13.2037 10.9147 13.9976 9.82484L16.368 14.2076L14.2693 13.7263Z"
          fill="black"
        />
        <path
          d="M9.0013 8.85286V3.70703L8.1888 4.10286M9.0013 8.85286H10.0846M9.0013 8.85286H7.91797"
          stroke="#171717"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30764_192193">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

function ViewDashboardDetails() {
  const { setIsLoadingPage } = useContext(LoaderContext);
  const buyerreg = useRef(null);
  const scrollDoneRef = useRef(false);
  const clearTimerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const params = useParams();
  const [response, setResponse] = useState();
  const { setLoaderConfig } = useContext(LoaderContext);
  const { winnerPopper, displayExchange } = useContext(PropertyContext);
  const {
    msgcount,
    setMsgcount,
    realTimeLog,
    msgbtn,
    selectedBuyerid,
    setSelectedBuyerid,
    setIschatopen,
    isOpenFileManager,
  } = useContext(datacontext);
  const [profileDetails, setProfileDetails] = useState({});
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [activityupdate, setActivityupdate] = useState(false);
  const [activity, setActivity] = useState(false);
  const [publish, setPublish] = useState(false);
  const [offerdata, setOfferdata] = useState(null);
  const [tablerow, setTablerow] = useState([]);
  const [loader, setLoader] = useState(true);
  const [swap, setSwap] = useState(false);
  const [items, setItems] = useState([1, 2, 3, 4, 5]);
  const [ordereditems, setOrdereditems] = useState([
    'Status',
    'Forecast',
    'Vendorstatus',
    'Offeractivity',
    'Buyerregister',
  ]);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  function handleDragEnd(event) {
    const { active, over } = event;

    if (!over) return;

    if (active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }

  const propertyId = params?.dashboardId;

  const Storeorder = () => {
    const letters = [
      'Status',
      'Forecast',
      'Vendorstatus',
      'Offeractivity',
      'Buyerregister',
    ];
    const data = items.map((value) => letters[value - 1]);
    setOrdereditems(data);
    const input = {
      sectionOrder: data,
      propertyId: propertyId,
    };
    postApiCall(STORE_SECTION_ORDER, input).then((res) => {
      // Sectionorderdata();
    });
  };

  //agent survey dialog state
  const [questionBox, setQuestionBox] = useState(false);
  // Callback function to update selected row data
  const [forecastData, setForecastData] = React.useState();
  const [acceptanceCertificate, setAcceptanceCertificate] = useState(false);
  const [stage2AcceptanceCertificate, setStage2AcceptanceCertificate] =
    useState(false);
  const updateSelectedRowData = (data) => {
    setSelectedRowData(data);
  };

  const [divHeight, setDivHeight] = useState(0);
  const divRef = useRef(null);

  useEffect(() => {
    const updateDivHeight = () => {
      if (divRef.current) {
        setDivHeight(divRef.current.offsetHeight);
      }
    };
    updateDivHeight();
    window.addEventListener('resize', updateDivHeight);
    return () => {
      window.removeEventListener('resize', updateDivHeight);
    };
  }, []);
  // useEffect dependency issue

  const [timerStatus, setTimerStatus] = useState();
  const [isStageTwo, setIsStageTwo] = useState();
  const [isWinner, setIsWinner] = useState();

  const getdata = () => {
    let url = '';
    const primaryUserTypeValue = JSON.parse(
      localStorage.getItem('primaryUser')
    );

    if (primaryUserTypeValue == 'Vendor') {
      url = OFFER_ACTIVITY_VENDOR;
    } else {
      url = OFFER_ACTIVITY;
    }
    getApiCall(url + `/${params?.dashboardId}`).then((res) => {
      setOfferdata(res?.data?.offerActivity);
      const wholedata = res?.data?.offerActivity;

      const stageTwoItems = res?.data?.offerActivity?.filter(
        (item) => item?.isStageTwo == 1
      );
      const highestStageTwoItem = stageTwoItems?.length
        ? stageTwoItems?.reduce((maxItem, current) => {
            const currentPrice = parseInt(
              current?.offerPrice?.replace(/\$|,/g, ''),
              10
            );
            const maxPrice = parseInt(
              maxItem?.offerPrice?.replace(/\$|,/g, ''),
              10
            );
            return currentPrice > maxPrice ? current : maxItem;
          })
        : null;

      const highestOverallItem = wholedata?.length
        ? wholedata?.reduce((maxItem, current) => {
            const currentPrice =
              parseInt(current?.offerPrice?.replace(/\$|,/g, ''), 10) || 0;
            const maxPrice =
              parseInt(maxItem?.offerPrice?.replace(/\$|,/g, ''), 10) || 0;
            return currentPrice > maxPrice ? current : maxItem;
          })
        : null;

      let newArray = wholedata?.slice().reverse();
      let data = [];
      if (newArray?.length > 0) {
        newArray.map((item, index) => {
          let a = parseInt(item.offerPrice.replace(/\$|,/g, ''), 10);
          let b = parseInt(
            newArray[index + 1]?.offerPrice.replace(/\$|,/g, ''),
            10
          );
          let percentage = b
            ? a < b
              ? '-' + ((b - a) * 100) / b
              : ((a - b) * 100) / b
            : 0;
          let formatteddate = dayjs(item?.createdAt)
            .locale('en')
            .format('HH:mm:ss DD-MM-YYYY');

          const isProcessingBadge =
            res?.data?.timerStage == 'ST2' &&
            res?.data?.timerStatus == 'End' &&
            res?.data?.isWinner == 0 &&
            item?.isStageTwo == 1 &&
            highestStageTwoItem &&
            item?.offerLogId == highestStageTwoItem?.offerLogId;
          let innerdata = {
            id: item?.offerLogId,
            Name: (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '3px',
                }}
              >
                {`${item?.buyerName || ''} ${item?.buyerSurName || ''}`}
                {item?.isWinner == 1 && <TrophyIcon color="2F3F5E" />}
                {item?.offerLogId == highestOverallItem?.offerLogId &&
                  item?.isWinner !== 1 && <BuyerhighestOffBadge />}
              </div>
            ),
            // Offer: item?.offerPrice,
            Offer: (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                  sx={{ fontWeight: 500, fontSize: '14px', color: '#22c55e' }}
                >
                  {item?.offerPrice}
                </Typography>

                <Box
                  sx={{
                    minWidth: 90,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {(isProcessingBadge || item?.isWinner == 1) && (
                    <Box
                      sx={{
                        borderRadius: '54px',
                        px: 1.5,
                        py: 0.5,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        border: '1px solid #AF52DE',
                        backgroundColor: 'rgba(175, 82, 222, 0.05)',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <TrophyIcon color="#AF52DE" />
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: '11px',
                          color: '#AF52DE',
                        }}
                      >
                        {isProcessingBadge ? 'Processing' : 'Winner'}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Stack>
            ),
            'Offer Date & Time': formatteddate,
            '% chng': b
              ? percentage < 1 && percentage > 0
                ? Number(percentage).toFixed(4) + '%'
                : Math.round(percentage) + '%'
              : '_',
            'Offer Type':
              item?.isConditional == 1 ? 'Conditional' : 'Unconditional',
            'Vendor Status': item?.vendorStatus
              ? item?.vendorStatus
              : 'No response',
            buyerId: item?.buyerId,
            offerUniqueId: item?.offerUniqueId,
            vendorStatus: item?.vendorStatus,
          };
          data.push(innerdata);
        });
        setTablerow(data);
        setTimerStatus(res?.data?.timerStatus);
        setIsStageTwo(res?.data?.timerStage);
        setIsWinner(res?.data?.isWinner);
      }
    });
  };

  useEffect(() => {
    getdata();
  }, [realTimeLog]);

  function scrollToBuyerBottom() {
    const container = divRef.current;
    const target = buyerreg.current;

    if (!container || !target) return;

    // target position relative to scroll container
    const targetOffset = target.offsetTop + target.offsetHeight;

    const maxScroll = container.scrollHeight - container.clientHeight;

    container.scrollTo({
      top: Math.min(targetOffset, maxScroll),
      behavior: 'smooth',
    });
  }

  useEffect(() => {
    if (!selectedBuyerid) return;
    if (!divRef.current || !buyerreg.current) return;

    // prevent duplicate execution
    if (scrollDoneRef.current) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToBuyerBottom();

        // ✅ mark scroll as done
        scrollDoneRef.current = true;

        // ✅ start timer ONLY AFTER scroll
        clearTimerRef.current = setTimeout(() => {
          setSelectedBuyerid(null);
          scrollDoneRef.current = false; // reset for next time
        }, 5000);
      });
    });

    return () => {
      if (clearTimerRef.current) {
        clearTimeout(clearTimerRef.current);
        clearTimerRef.current = null;
      }
    };
  }, [selectedBuyerid, buyerreg.current]);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Banner api Recall

  const { getBannerData, bannerData } = useAgentBannerData(propertyId, false);

  // const open = Boolean(anchorEl);
  const id = open ? 'dialog' : undefined;
  const [dataUpdate, setDataUpdate] = useState(false);
  const getListInfo = async (from) => {
    Sectionorderdata();
    // setLoaderConfig({ isVisible: true, show: true });
    await getApiCall(GET_PROPERTY_INDIVIDUAL + `/${params?.dashboardId}`)
      .then(async (res) => {
        if (res?.data?.status == '-1') {
          toast.error(res?.data?.message, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: 0,
            theme: 'light',
            style: {
              fontFamily: 'Poppins', // 👈 Inline Poppins font
            },
          });
        } else {
          await setProfileDetails(res?.data);
          getBannerData();
          if (from == 'apiupdated') {
            setDataUpdate(!dataUpdate);
          }
          await getForecastData(params?.dashboardId).then((res) => {
            setResponse(res?.status);
            if (res?.status == '1') {
              setForecastData(res?.data);
            } else {
              setForecastData([]);
            }
          });
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const Sectionorderdata = () => {
    getApiCall(GET_SECTION_ORDER + `${propertyId}`).then((response) => {
      if (response?.data?.status == 1) {
        setOrdereditems(response?.data?.sectionOrder?.sectionOrder);
        const updateItemState = () => {
          const indexMap = {};
          ordereditems.forEach((item, index) => {
            indexMap[item] = index;
          });
          const newItemState = response?.data?.sectionOrder?.sectionOrder.map(
            (item) => items[indexMap[item]]
          );
          setItems(newItemState);
        };
        updateItemState();
      }
    });
  };
  useEffect(() => {
    getListInfo();
  }, [params?.dashboardId, dataUpdate, realTimeLog]);

  const buyersId = profileDetails?.PropertyDetails;
  const listData = [
    {
      cardLogoBgColor: 'rgba(16, 211, 94, 0.1)',
      cardText: 'Buyers Inspected',
      cardValue: `${profileDetails?.PropertyDetails?.inspectedCount}`,
      keyVal: 'buyers',
      cardIndicator: 'vectorup',
      cardLogo: StatusLiveIcon,
    },
    {
      cardLogoBgColor: 'rgba(249, 57, 57, 0.1)',
      cardText: 'Interested Parties',
      cardValue: `${profileDetails?.PropertyDetails?.interestedCount}`,
      keyVal: 'interested',
      cardIndicator: 'vectordown',
      cardLogo: Goal,
    },
    {
      cardLogoBgColor: 'rgba(47, 116, 238, 0.1)',
      cardText: 'Offers',
      cardValue: `${profileDetails?.PropertyDetails?.offerCount}`,
      keyVal: 'Offers',
      cardIndicator: 'vectorup',
      cardLogo: Currency,
    },
  ];

  let currentStatus =
    profileDetails?.PropertyDetails?.property?.status == 'Unpublish'
      ? false
      : true;

  let publishStatus = profileDetails?.PropertyDetails?.property?.status;

  // const liveDays = (publishStatus == "Unpublish" ? "Commence" : "Live") + `(${profileDetails?.PropertyDetails?.liveDays} Days)`;
  // const liveDays = (publishStatus == "Unpublish" ? "Commencing in" : "Live") + (publishStatus == "Unpublish" ? `(${profileDetails?.PropertyDetails?.commencingDays || 0} Days)` : `(${profileDetails?.PropertyDetails?.liveDays} Days)`);

  const liveDays =
    publishStatus === 'Unpublish'
      ? profileDetails?.PropertyDetails?.commencingDays > 0
        ? `Commencing in (${profileDetails?.PropertyDetails?.commencingDays} ${
            profileDetails?.PropertyDetails?.commencingDays === 1
              ? 'Day'
              : 'Days'
          })`
        : 'Commencing soon'
      : profileDetails?.PropertyDetails?.liveDays > 0
      ? `Live (${profileDetails?.PropertyDetails?.liveDays} ${
          profileDetails?.PropertyDetails?.liveDays === 1 ? 'Day' : 'Days'
        })`
      : 'Live today';

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
    setSelectedBuyerid(binderId);
  };

  const history = useHistory();

  const token = localStorage.getItem('moxoDetail');
  const bearerToken = JSON.parse(token);

  const activityfun = () => {
    setActivityupdate(!activityupdate);
  };

  const onClose = () => {
    setOpen(false);
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xl'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const dataType = userDetail?.userType;
  const userTypeValue = JSON.parse(localStorage.getItem('primaryUser'));
  const [buyerRegisterTableData, setBuyerRegisterTableData] = useState('');
  // to share winning offer
  const [openShareWinner, setOpenShareWinner] = useState(false);
  // to open deposit manager
  const [openDepositManager, setOpenDepositManager] = useState(false);
  const [confirmDeposit, setConfirmDeposit] = useState(false);
  // const [openCommenceStateTwo, setOpenCommenceStateTwo] = useState(false);
  const [openCommenceStageTwo, setOpenCommenceStageTwo] = useState(false);

  // intiate signrequest
  const [openFinalContractDialog, setOpenFinalContractDialog] = useState(false);
  const [uploadedContractUrl, setUploadedContractUrl] = useState(null);
  const [openPrepareDialog, setOpenPrepareDialog] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadedPdf, setUploadedPdf] = useState(null);

  const primaryOwner =
    profileDetails?.PropertyDetails?.propertyOwnerDetails?.find(
      (owner) => owner?.isPrimary === 1
    );

  const primaryVendor =
    profileDetails?.PropertyDetails?.propertyOwnerDetails?.find(
      (vendor) => vendor?.isPrimary === 1
    );
  const vendorFullName = `${primaryVendor?.user?.userName || ''} ${
    primaryVendor?.user?.userSurName || ''
  }`.trim();

  const winnerFullName = `${
    profileDetails?.PropertyDetails?.winnerName || ''
  }`.trim();

  const handleCloseDepositManager = () => {
    setOpenDepositManager(false);
  };
  const handleCloseShareWinner = () => {
    setOpenShareWinner(false);
  };

  const handleUpdateBuyerData = (updatedData) => {
    setBuyerRegisterTableData(updatedData);
  };

  const themes = {
    background: '#0065FC',
    fontFamily: 'poppins',
    headerBgColor: '#0065FC',
    headerFontColor: '#fff',
    headerFontSize: '15px',
    botBubbleColor: '#bcbbbc1a',
    botFontColor: '#0065FC',
    userBubbleColor:
      'linear-gradient(162.58deg, #6c2ad2 1.87%, #77cffe 98.78%) !important',
    userFontColor: '#fff',
  };

  const Locationwhite = () => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.0358 2.66706C9.89042 2.64618 4.87086 7.53546 4.67023 13.6555L4.66406 14.0353C4.76621 17.0351 5.78683 19.8946 7.58444 22.2505L8.00662 22.8014C9.72247 24.9831 11.7615 26.8981 14.0511 28.4765L14.6023 28.8476L14.6828 28.9107C15.4675 29.4746 16.5271 29.4746 17.3118 28.9107L17.3788 28.8557C19.1955 27.6775 20.8707 26.2932 22.3714 24.73C25.4222 21.5006 27.261 17.882 27.3304 14.207L27.3306 14.0705C27.3514 7.90955 22.4772 2.87455 16.376 2.67325L16.0358 2.66706ZM16.0295 4.6901C21.0675 4.70733 25.1579 8.73271 25.3098 13.7456L25.3141 14.1876C25.2558 17.2687 23.6425 20.4434 20.9134 23.3323C19.5218 24.7818 17.9616 26.0702 16.2693 27.1661L16.1566 27.2509C16.0654 27.33 15.9302 27.33 15.8391 27.2509L15.7295 27.1681C13.2086 25.5222 10.996 23.4442 9.19308 21.0291C7.74084 19.1257 6.88027 16.85 6.70705 14.476L6.6816 14C6.69871 8.94977 10.7117 4.84679 15.7092 4.69444L16.0295 4.6901ZM15.9957 9.86907C13.6112 9.86907 11.6781 11.8081 11.6781 14.2C11.6781 16.5918 13.6112 18.5308 15.9957 18.5308C18.3802 18.5308 20.3133 16.5918 20.3133 14.2C20.3133 11.8081 18.3802 9.86907 15.9957 9.86907ZM15.9962 11.8922C17.2668 11.8922 18.2968 12.9254 18.2968 14.1998C18.2968 15.4743 17.2668 16.5075 15.9962 16.5075C14.7257 16.5075 13.6957 15.4743 13.6957 14.1998C13.6957 12.9254 14.7257 11.8922 15.9962 11.8922Z"
          fill="#fff"
        />
      </svg>
    );
  };

  //survey question from Get Api
  const [openFromBannerCommenceStageTwo, setOpenFromBannerCommenceStageTwo] =
    useState(false);
  const [openFromBannerNominateWinner, setOpenFromBannerNominateWinner] =
    useState(false);

  //chatbot filtered question to popup display
  useEffect(() => {
    if (
      profileDetails?.isSurveyCompleted == 0 &&
      Object.keys(profileDetails).length != 0
    ) {
      getApiCall(`${AGENT_GETQUESTION}/${propertyId}`).then((res) => {
        const result = res?.data?.agentQuestions.filter(
          (value) => value.questionAnswer == ''
        );
        const questionsData = {
          priceRange: res?.data?.priceRange,
          propertyId: propertyId,
          address:
            profileDetails?.PropertyDetails?.propertyAddress?.streetName || '',
          questions: result,
        };

        localStorage.setItem('questions', JSON.stringify(questionsData));
        const Issurveyskip = async () => {
          let issurveyskipped = await localStorage.getItem('issurveyskipped');
          if (!issurveyskipped) {
            history.replace('/Agentfeedback');
          }
        };
        Issurveyskip();
      });
    }
  }, [profileDetails?.isSurveyCompleted]);

  const CustomComponent2 = ({ itemId }) => {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({ id: itemId });
    if (itemId == 1) {
      return (
        <div
          ref={setNodeRef}
          style={{
            transform: transform
              ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
              : undefined,
            transition,
            cursor: 'grab',
          }}
          {...attributes}
          {...listeners}
        >
          <StatusCardContainer
            title="Status "
            listData={listData}
            subTitle={liveDays}
            profileDetails={profileDetails}
            showclick={true}
            getListInfo={getListInfo}
          />
        </div>
      );
    } else if (itemId == 2) {
      return (
        <div
          ref={setNodeRef}
          style={{
            transform: transform
              ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
              : undefined,
            transition,
            cursor: 'grab',
          }}
          {...attributes}
          {...listeners}
        >
          <ForecastContainer
            forecastData={forecastData}
            response={response}
            profileDetails={profileDetails}
            currentStatus={currentStatus}
          />
        </div>
      );
    } else if (itemId == 3) {
      return (
        <div
          ref={setNodeRef}
          style={{
            transform: transform
              ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
              : undefined,
            transition,
            cursor: 'grab',
          }}
          {...attributes}
          {...listeners}
        >
          <VendorStatusContainer
            profileDetails={profileDetails}
            onShowChat={onShowChat}
            binders={true}
            getListInfo={getListInfo}
            activityfun={activityfun}
            offerdata={getdata}
            buyerRegisterTableData={buyerRegisterTableData}
            acceptanceCertificate={acceptanceCertificate}
            setAcceptanceCertificate={setAcceptanceCertificate}
            stage2AcceptanceCertificate={stage2AcceptanceCertificate}
            setStage2AcceptanceCertificate={setStage2AcceptanceCertificate}
            openCommenceStageTwo={openCommenceStageTwo}
            setOpenCommenceStageTwo={setOpenCommenceStageTwo}
          />
        </div>
      );
    } else if (itemId == 4) {
      return (
        <div
          ref={setNodeRef}
          style={{
            transform: transform
              ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
              : undefined,
            transition,
            cursor: 'grab',
          }}
          {...attributes}
          {...listeners}
        >
          <Offeractivity
            getListInfo={getListInfo}
            offerdata={offerdata}
            setOfferdata={setOfferdata}
            setTablerow={setTablerow}
            tablerow={tablerow}
            getdata={getdata}
            buyerRegisterTableData={buyerRegisterTableData}
            timerStatus={timerStatus}
            isStageTwo={isStageTwo}
            isWinner={isWinner}
          />
        </div>
      );
    } else if (itemId == 5) {
      return (
        <div
          ref={setNodeRef}
          style={{
            transform: transform
              ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
              : undefined,
            transition,
            cursor: 'grab',
          }}
          {...attributes}
          {...listeners}
        >
          <BuyerRegistration
            profileDetails={profileDetails}
            onClick={handleClick}
            id={id}
            getListInfo={getListInfo}
            onShowChat={onShowChat}
            activityfun={activityfun}
            publishwinner={publish}
            getdata={getdata}
            userTypeValue={userTypeValue}
            realTimeLog={realTimeLog}
            onFilterUpdate={handleUpdateBuyerData}
            propertyId={propertyId}
          />
        </div>
      );
    }
  };

  // for exchange dialog
  const [showExchange, setShowExchange] = useState(false);
  const [openExchange, setOpenExchange] = useState(false);

  const [showUpdateExchange, setShowUpdateExchange] = useState(false);
  const [openUpdateExchange, setOpenUpdateExchange] = useState(false);

  // for settlement dialog
  const [showSettlement, setShowSettlement] = useState(false);
  const [openSettlement, setOpenSettlement] = useState(false);
  const [showUpdateSettlement, setShowUpdateSettlement] = useState(false);
  const [openUpdateSettlement, setOpenUpdateSettlement] = useState(false);

  //update listing status dialogbox
  const [showUpdateListing, setShowUpdateListing] = useState(false);
  const [openUpdateListing, setOpenUpdateListing] = useState(false);

  // to nominate alternate winner  db
  const [openpublishwinnerbox, setOpenPublishWinnerBox] = useState(false);

  // const handleNominateClose=()=>{
  //   setOpenPublishWinnerBox(false)
  // }

  const location = useLocation();

  // state to open request deposit popup
  const [depFlow, setDepFlow] = useState(false);
  const [requestdeposit, setRequestdeposit] = useState(false);
  // const [depositdetails, setDepositdetails] = useState(false);
  const [depositRes, setDepositRes] = useState('');
  const [selectedrow, setSelectedrow] = useState({});
  const [reqDepositOpen, setReqDepositOpen] = useState(false);
  // const [selectedBuyerId, setSelectedBuyerId] = useState('');
  const [selectedrowbuyername, setSelectedrowbuyername] = React.useState(false);
  const [selectedrowbuyerid, setSelectedrowbuyerid] = React.useState(false);
  const [
    endPropertyPopupFromNominateWinner,
    setEndPropertyPopupFromNominateWinner,
  ] = useState(false);

  useEffect(() => {
    if (location?.state?.dashboardConfiremDepositBanner) {
      setConfirmDeposit(true);
    }
  }, [location?.state?.dashboardConfiremDepositBanner]);

  useEffect(() => {
    if (location?.state?.dashboardCommenceStage2) {
      setOpenCommenceStageTwo(true);
    }
  }, [location?.state?.dashboardCommenceStage2]);

  const hancleCloseUpdate = () => {
    setShowUpdateListing(false);
    getListInfo();
  };

  const handleCloseExchangeUpdate = () => {
    setOpenUpdateExchange(false);
  };

  const handleCloseSettlementUpdate = () => {
    setOpenUpdateSettlement(false);
  };

  dayjs.extend(utc);
  dayjs.extend(timezone);

  // useEffect(() => {
  //   if (location.state?.openShareWinner) {
  //     setOpenShareWinner(true);
  //   } else if (location.state?.fromDashBoard) {
  //     setOpenPublishWinnerBox(true);
  //   }
  //   // else if (location.state?.isFromConfirmExchange && profileDetails) {
  //   //   setOpenExchange(true);
  //   //   setShowExchange(true);
  //   //   history.push({
  //   //     pathname: history.location.pathname,
  //   //     state: { isFromConfirmExchange: false },
  //   //   });
  //   // }
  // }, [profileDetails]);
  const [WinnerBuyerId, SetWinnerBuyerId] = useState(false);
  const [user, setUser] = useState('');
  const [signBuyerId, setSignBuyerId] = useState(0);

  const handleFinalContractSubmit = async (file, buyerIdFromSelection) => {
    setUploadedPdf(file);
    setSignBuyerId(buyerIdFromSelection || 0);
    setOpenUploadDialog(false);
    setOpenPrepareDialog(true);
    try {
      const formData = new FormData();
      const userType = user;

      formData.append('propertyId', params?.dashboardId);

      formData.append('buyerId', userType === 'buyer' ? WinnerBuyerId : 0);
      formData.append('signBuyerId', 0);

      formData.append(
        'vendorId',
        userType === 'vendor'
          ? profileDetails?.PropertyDetails?.propertyOwnerDetails?.[0]?.user
              ?.userId
          : 0
      );
      // formData.append('vendorId', 0);
      // formData.append('buyerId', location?.state?.winnerBuyerId);
      formData.append('contractFile', file);
      const response = await postApiCall(CONTRACT_FILE_UPLOAD, formData);
      if (response?.data?.status === 1) {
        setUploadedContractUrl(response.data.contractFile);
      }
    } catch (error) {}
  };

  const handleCloseFinalContractDialog = () => {
    setOpenFinalContractDialog(false);
  };

  const handleCloseAllContractDialogs = () => {
    setOpenPrepareDialog(false);
    setOpenFinalContractDialog(false);
  };

  const handleClosePrepareDialog = () => {
    setOpenPrepareDialog(false);
  };

  useEffect(() => {
    const raw = sessionStorage.getItem('navAction');
    if (!raw) return;
    const action = JSON.parse(raw);
    sessionStorage.removeItem('navAction');
    // ---------------- DEPOSIT FLOW ----------------
    if (action.type === 'deposit') {
      SetWinnerBuyerId(action.winningBuyerId);

      if (!action.depositFlow) {
        setOpenDepositManager(true);
        return;
      }
      setDepFlow(true);
      return;
    }
    // ---------------- CONTRACT FLOW ----------------
    if (action.type === 'contract') {
      SetWinnerBuyerId(action.winningBuyerId);
      setUser(action.user);
      setOpenFinalContractDialog(true);
      return;
    }
  }, [profileDetails]);

  useEffect(() => {
    if (!profileDetails?.BuyerRegisterDetails || !WinnerBuyerId || !depFlow)
      return;

    const filtered = profileDetails.BuyerRegisterDetails.find(
      (item) =>
        Number(item?.buyerDetails?.user?.userId) === Number(WinnerBuyerId)
    );

    if (!filtered) return;
    setSelectedrow(filtered);
    setSelectedrowbuyerid(WinnerBuyerId);
    setTimeout(() => setRequestdeposit(true), 1000);

    const user = filtered?.buyerDetails?.user;
    setSelectedrowbuyername(
      `${user?.userName ?? ''} ${user?.userSurName ?? ''}`.trim()
    );

    setDepFlow(false);
  }, [profileDetails, WinnerBuyerId, depFlow]);

  useEffect(() => {
    if (location.state?.openShareWinner) {
      setOpenShareWinner(true);
      history.replace({
        pathname: history.location.pathname,
        state: {},
      });
    } else if (location.state?.fromDashBoard) {
      setOpenPublishWinnerBox(true);

      history.replace({
        pathname: history.location.pathname,
        state: {},
      });
    }
  }, [profileDetails]);

  useEffect(() => {
    const exchangedAtStr =
      profileDetails?.PropertyDetails?.exchangedStatus?.exchangedAt;
    const settlementDays =
      profileDetails?.PropertyDetails?.exchangedStatus?.settlementDays ?? 0;

    const exchangedAt = dayjs.tz(
      exchangedAtStr,
      'YYYY-MM-DD HH:mm:ss',
      'Australia/Sydney'
    );

    // Total time = settlementDays + 1 day (24 hours)
    const totalHours = (settlementDays + 1) * 24;
    const targetTime = exchangedAt.add(totalHours, 'hour');

    // Resume time from API (assumed to be in 'Australia/Sydney' timezone)
    const resumeAtStr =
      profileDetails?.PropertyDetails?.cancelActionDetails?.resumeAt;

    const resumeAtSydney = dayjs.tz(
      resumeAtStr,
      'YYYY-MM-DD HH:mm:ss',
      'Australia/Sydney'
    );

    // Get current time in Sydney
    const nowSydney = dayjs().tz('Australia/Sydney');

    // Existing logic (SAFE)
    // Compare the two
    const resumeTime =
      nowSydney.isAfter(resumeAtSydney) || nowSydney.isSame(resumeAtSydney);
    // Check if it's time to show
    const firstTimeDisplay = nowSydney >= targetTime;

    const shouldShow =
      resumeAtStr == null && resumeAtStr == undefined
        ? firstTimeDisplay
        : resumeTime;

    /* ================== ADDED DOCUMENT CONDITIONS ================== */

    // const resumedAtStrDoc = profileDetails?.PropertyDetails?.resumedAt;

    // const resumedAtSydneyDoc = resumedAtStrDoc
    //   ? dayjs.tz(resumedAtStrDoc, 'YYYY-MM-DD HH:mm:ss', 'Australia/Sydney')
    //   : null;

    // // resumedAt IS NULL/Undefined OR resumedAt <= currentTime
    // const resumedAtCondition =
    //   resumedAtSydneyDoc == null ||
    //   nowSydney.isSame(resumedAtSydneyDoc) ||
    //   nowSydney.isAfter(resumedAtSydneyDoc);

    // // exchangedAt + settlementDays + 24 hours <= resumedAt
    // const exchangedBeforeResume =
    //   resumedAtSydneyDoc != null &&
    //   targetTime != null &&
    //   (targetTime.isSame(resumedAtSydneyDoc) ||
    //     targetTime.isBefore(resumedAtSydneyDoc));

    /* ================== OLD CONDITIONS (UNCHANGED) ================== */

    if (
      displayExchange &&
      !location.state?.fromDashBoard &&
      resumeTime &&
      profileDetails?.PropertyDetails?.vendorEsignStatus == 'Completed' &&
      profileDetails?.PropertyDetails?.isWinner == 1 &&
      profileDetails?.PropertyDetails?.isWinnerDepositStatus == 'Completed' &&
      profileDetails?.PropertyDetails?.isWinnerContractSignStatus ==
        'Completed' &&
      profileDetails?.PropertyDetails?.exchangedStatus == null
      //  &&
      // (profileDetails?.PropertyDetails?.resumedAt == null ||
      //   profileDetails?.PropertyDetails?.resumedAt == undefined) &&
      // resumedAtCondition
    ) {
      setOpenExchange(true);
      setShowExchange(true);
    }
    const timerStatusUpdatedAt =
      profileDetails?.PropertyDetails?.timerStatusUpdatedAt;
    const sevenDaysPassed =
      timerStatusUpdatedAt &&
      dayjs().isAfter(dayjs(timerStatusUpdatedAt).add(7, 'day'));

    if (
      profileDetails?.PropertyDetails?.isWinner == 0 &&
      sevenDaysPassed &&
      profileDetails?.PropertyDetails?.timerStatus == 'End' &&
      !profileDetails?.PropertyDetails?.isArchived == 1
    ) {
      setShowUpdateListing(true);
      setOpenUpdateListing(true);
    }

    if (
      shouldShow &&
      profileDetails?.PropertyDetails?.exchangedStatus?.status == 'Exchanged'
      //  &&
      // !profileDetails?.PropertyDetails?.isArchived == 1 &&
      // (profileDetails?.PropertyDetails?.resumedAt == null ||
      //   profileDetails?.PropertyDetails?.resumedAt == undefined) &&
      // (resumedAtSydneyDoc == null ||
      //   (resumedAtCondition && exchangedBeforeResume))
    ) {
      setShowSettlement(true);
      setOpenSettlement(true);
    }
  }, [profileDetails, displayExchange]);
  return (
    <>
      {loader ? (
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box>
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{
                height: matchessm ? '100px' : '200px',
                width: matchessm ? '100px' : '200px',
              }}
            />
          </Box>
          <Typography sx={{ fontFamily: 'poppins' }}>Loading...</Typography>
        </Grid>
      ) : (
        <>
          {msgbtn && matches ? (
            <MessagingContainer
              binders={false}
              activityupdate={activityupdate}
            />
          ) : (
            <Grid
              container
              style={{
                height: '100%',
                overflow: 'hidden',
              }}
            >
              {isOpenFileManager ? (
                <Grid
                  ref={divRef}
                  item
                  sx={{
                    width: matcheslg ? '100%' : '80%',
                    marginTop: !matches && '25px',
                    height: '100%',
                    overflowY: 'auto',
                    padding: matchessm
                      ? '20px 5px'
                      : matchesmd
                      ? '32px'
                      : matches
                      ? '32px'
                      : '10px',
                    pr: matchessm ? '5px' : '20px',
                    pb: 10,
                  }}
                >
                  <DocumentHub
                    propertyAddress={
                      profileDetails?.PropertyDetails?.propertyAddress
                        ?.streetName
                    }
                    userType={userTypeValue}
                    getListInfo={getListInfo}
                  />
                </Grid>
              ) : (
                <Grid
                  ref={divRef}
                  item
                  sx={{
                    width: matcheslg ? '100%' : '80%',
                    marginTop: !matches && '25px',
                    height: '100%',
                    overflowY: 'auto',
                    padding: matchessm
                      ? '20px 5px'
                      : matchesmd
                      ? '32px'
                      : matches
                      ? '32px'
                      : '10px',
                    pr: matchessm ? '5px' : '20px',
                    pb: 10,
                  }}
                >
                  <LocationDetails
                    sx={locationStyles}
                    profileDetails={profileDetails}
                    activitystatus={setActivity}
                    setSwap={setSwap}
                    swap={swap}
                    Storeorder={Storeorder}
                  />
                  {/* individual */}
                  <div>
                    <IndexAgentBanners
                      isAgentIndividual={true}
                      isAgentDashboard={false}
                      profileDetails={profileDetails}
                      getListInfo={getListInfo}
                      setOpenCommenceStageTwo={setOpenCommenceStageTwo}
                      setOpenFromBannerNominateWinner={
                        setOpenFromBannerNominateWinner
                      }
                      setOpenExchange={setOpenExchange}
                      setShowExchange={setShowExchange}
                      setShowSettlement={setShowSettlement}
                      setOpenSettlement={setOpenSettlement}
                      propertyId={propertyId}
                      confirmDeposit={confirmDeposit}
                      setConfirmDeposit={setConfirmDeposit}
                      getBannerData={getBannerData}
                      bannerData={bannerData}
                    />
                  </div>

                  {activity && matches ? (
                    <Grid sx={{ marginTop: '20px' }}>
                      <ActivityContainer
                        individual={true}
                        activityupdate={activityupdate}
                      />
                    </Grid>
                  ) : null}

                  {matcheslg && profileDetails?.status == 1 && (
                    <LiveOfferStatus
                      profileDetails={profileDetails}
                      getListInfo={getListInfo}
                      activityfun={activityfun}
                      setPublish={setPublish}
                      offerdata={getdata}
                      stage2AcceptanceCertificate={stage2AcceptanceCertificate}
                      setStage2AcceptanceCertificate={
                        setStage2AcceptanceCertificate
                      }
                    />
                  )}

                  {swap ? (
                    <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleDragEnd}
                    >
                      <SortableContext
                        items={items}
                        strategy={verticalListSortingStrategy}
                      >
                        {items.map((item) => (
                          <CustomComponent2 key={item} itemId={item} />
                        ))}
                      </SortableContext>
                    </DndContext>
                  ) : (
                    [1, 2, 3, 4, 5].map((count, index) => {
                      return ordereditems[index] === 'Status' ? (
                        <StatusCardContainer
                          title="Status "
                          listData={listData}
                          subTitle={
                            publishStatus == 'Unpublish' &&
                            profileDetails?.PropertyDetails?.timerDuration == 0
                              ? ''
                              : liveDays
                          }
                          profileDetails={profileDetails}
                          showclick={true}
                          getListInfo={getListInfo}
                        />
                      ) : ordereditems[index] == 'Forecast' ? (
                        <ForecastContainer
                          forecastData={forecastData}
                          response={response}
                          profileDetails={profileDetails}
                          currentStatus={currentStatus}
                        />
                      ) : ordereditems[index] == 'Vendorstatus' ? (
                        <VendorStatusContainer
                          profileDetails={profileDetails}
                          onShowChat={onShowChat}
                          binders={true}
                          getListInfo={getListInfo}
                          activityfun={activityfun}
                          offerdata={getdata}
                          buyerRegisterTableData={buyerRegisterTableData}
                          acceptanceCertificate={acceptanceCertificate}
                          setAcceptanceCertificate={setAcceptanceCertificate}
                          stage2AcceptanceCertificate={
                            stage2AcceptanceCertificate
                          }
                          setStage2AcceptanceCertificate={
                            setStage2AcceptanceCertificate
                          }
                          openFromBannerCommenceStageTwo={
                            openFromBannerCommenceStageTwo
                          }
                          setOpenFromBannerCommenceStageTwo={
                            setOpenFromBannerCommenceStageTwo
                          }
                          openCommenceStageTwo={openCommenceStageTwo}
                          setOpenCommenceStageTwo={setOpenCommenceStageTwo}
                        />
                      ) : ordereditems[index] == 'Offeractivity' ? (
                        <Offeractivity
                          getListInfo={getListInfo}
                          offerdata={offerdata}
                          setOfferdata={setOfferdata}
                          setTablerow={setTablerow}
                          tablerow={tablerow}
                          getdata={getdata}
                          buyerRegisterTableData={buyerRegisterTableData}
                          timerStatus={timerStatus}
                          isStageTwo={isStageTwo}
                          isWinner={isWinner}
                        />
                      ) : ordereditems[index] == 'Buyerregister' ? (
                        <div>
                          <BuyerRegistration
                            profileDetails={profileDetails}
                            onClick={handleClick}
                            id={id}
                            getListInfo={getListInfo}
                            onShowChat={onShowChat}
                            activityfun={activityfun}
                            publishwinner={publish}
                            getdata={getdata}
                            userTypeValue={userTypeValue}
                            onFilterUpdate={handleUpdateBuyerData}
                            openFromBannerNominateWinner={
                              openFromBannerNominateWinner
                            }
                            propertyId={propertyId}
                          />
                          <div ref={buyerreg} />
                        </div>
                      ) : null;
                    })
                  )}
                  {winnerPopper && (
                    <WinnerPopperComponent trigger={winnerPopper} />
                  )}

                  {profileDetails?.isAuction == 1 && (
                    <Auction
                      profileDetails={profileDetails}
                      auctionTable={true}
                    />
                  )}
                </Grid>
              )}
              {!matcheslg && (
                <Grid
                  item
                  sx={{
                    width: '20%',
                    position: 'sticky',
                    top: '75px', // header height
                    height: '100%', // 🔥 CRITICAL
                    display: 'flex',
                    flexDirection: 'column',
                    padding:
                      profileDetails?.status == 1
                        ? '0px 14px 0 4px'
                        : '35px 14px 0 4px',
                    overflow: 'hidden', // 🔥 IMPORTANT
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      overflowY: 'auto', // ✅ ONLY PLACE SCROLL HERE
                      paddingRight: '4px',
                    }}
                  >
                    <Box
                      sx={{
                        overflowY: 'auto', // ✅ ONLY PLACE SCROLL HERE
                        paddingRight: '4px',
                        maxHeight: '500px',
                        minHeight: 'fit-content',
                      }}
                    >
                      {profileDetails?.status == 1 && (
                        <LiveOfferStatus
                          profileDetails={profileDetails}
                          getListInfo={getListInfo}
                          activityfun={activityfun}
                          setPublish={setPublish}
                          offerdata={getdata}
                          stage2AcceptanceCertificate={
                            stage2AcceptanceCertificate
                          }
                          setStage2AcceptanceCertificate={
                            setStage2AcceptanceCertificate
                          }
                        />
                      )}
                    </Box>
                    <Box
                      sx={{
                        paddingTop: '20px',
                        maxHeight: '500px',
                        overflow: 'scroll',
                      }}
                    >
                      {' '}
                      <ActivityContainer
                        individual={true}
                        activityupdate={activityupdate}
                      />
                    </Box>
                    <Box
                      sx={{
                        height: '500px',
                        overflow: 'hidden',
                        marginY: '20px',
                      }}
                    >
                      <MessagingContainer
                        binders={true}
                        activityupdate={activityupdate}
                      />
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          )}
        </>
      )}
      {modalIsOpen && (
        <Moxochat
          key={selectedBuyerid}
          binderId={selectedBuyerid}
          open={modalIsOpen}
          onClose={setModalIsOpen}
        />
      )}

      {showExchange && (
        <ExchangeConfirmDialog
          openConfirm={openExchange}
          setOpenConfirm={setOpenExchange}
          price={profileDetails?.PropertyDetails?.winningOffer}
          winner={profileDetails?.PropertyDetails?.winnerName}
          propAddress={
            profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          depositAmount={profileDetails?.PropertyDetails?.isWinnerDepositAmount}
          WinnerDepositAmountInt={
            profileDetails?.PropertyDetails?.isWinnerDepositAmountInt
          }
          settlementDays={profileDetails?.PropertyDetails?.winnerSettlementDays}
          propertyId={profileDetails?.PropertyDetails?.property?.propertyId}
          buyerId={profileDetails?.PropertyDetails?.isWinnerId}
          setShowUpdateExchange={setShowUpdateExchange}
          setOpenUpdateExchange={setOpenUpdateExchange}
          buyerContract={profileDetails?.PropertyDetails?.isWinnerContractFile}
          vendorContract={profileDetails?.PropertyDetails?.vendorContractFile}
          setOpenShareWinner={setOpenShareWinner}
          profileDetails={profileDetails}
        />
      )}

      {showUpdateExchange && (
        <ExchangeStatusDialog
          open={openUpdateExchange}
          onClose={handleCloseExchangeUpdate}
          price={profileDetails?.PropertyDetails?.winningOffer}
          winner={profileDetails?.PropertyDetails?.winnerName}
          propAddress={
            profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          depositAmount={profileDetails?.PropertyDetails?.isWinnerDepositAmount}
          settlementDays={profileDetails?.PropertyDetails?.winnerSettlementDays}
          propertyId={profileDetails?.PropertyDetails?.property?.propertyId}
          buyerId={profileDetails?.PropertyDetails?.isWinnerId}
          profileDetails={profileDetails}
          setOpenPublishWinnerBox={setOpenPublishWinnerBox}
          isIndividual={true}
        />
      )}

      {showSettlement && (
        <SettlementConfirm
          openSettleConfirm={openSettlement}
          setOpenSettleConfirm={setOpenSettlement}
          price={profileDetails?.PropertyDetails?.winningOffer}
          winner={profileDetails?.PropertyDetails?.winnerName}
          propAddress={
            profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          depositAmount={profileDetails?.PropertyDetails?.isWinnerDepositAmount}
          propertyId={profileDetails?.PropertyDetails?.property?.propertyId}
          buyerId={profileDetails?.PropertyDetails?.isWinnerId}
          setShowUpdateSettlement={setShowUpdateSettlement}
          setOpenUpdateSettlement={setOpenUpdateSettlement}
          getListInfo={getListInfo}
          buyerContract={profileDetails?.PropertyDetails?.isWinnerContractFile}
          vendorContract={profileDetails?.PropertyDetails?.vendorContractFile}
          profileDetails={profileDetails}
        />
      )}

      {showUpdateSettlement && (
        <SettlementStatusDialog
          open={openUpdateSettlement}
          onClose={handleCloseSettlementUpdate}
          propertyId={profileDetails?.PropertyDetails?.property?.propertyId}
          buyerId={profileDetails?.PropertyDetails?.isWinnerId}
          profileDetails={profileDetails}
          propAddress={
            profileDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          setOpenPublishWinnerBox={setOpenPublishWinnerBox}
        />
      )}

      {showUpdateListing && (
        <UpdateListingPopup
          open={openUpdateListing}
          setShowUpdateListing={setShowUpdateListing}
          onClose={() => setShowUpdateListing(false)}
          profileDetails={profileDetails}
        />
      )}

      <NominateWinnerDialog
        open={openpublishwinnerbox}
        onClose={() => setOpenPublishWinnerBox(false)}
        matchessm={matchessm}
        propAddress={
          profileDetails?.PropertyDetails?.propertyAddress?.streetName
        }
        profileDetails={profileDetails}
        buyerId={profileDetails?.PropertyDetails?.isWinnerId}
        setOpenPublishWinnerBox={setOpenPublishWinnerBox}
        getdata={getdata}
        getListInfo={getListInfo}
      />

      {/* dialog to share winner */}
      <ShareWinnerDialog
        open={openShareWinner}
        onClose={handleCloseShareWinner}
        tableData={profileDetails}
        buyerId={profileDetails?.PropertyDetails?.isWinnerId}
        getdata={getdata}
        getListInfo={getListInfo}
        propAddress={
          profileDetails?.PropertyDetails?.propertyAddress?.streetName
        }
        matchessm={matchessm}
        profileDetails={profileDetails}
      />

      {/* to open deposit manager */}
      {openDepositManager && (
        <DetailsPopup
          openDetailsPopup={openDepositManager}
          handleCloseDetails={handleCloseDepositManager}
          profileDetails={profileDetails}
          buyerId={WinnerBuyerId}
          isFromBuyerRegister={true}
          getListInfo={getListInfo}
        />
      )}

      {/* to initate sign request */}
      <FinalContractUploadDialog
        open={openFinalContractDialog}
        onClose={handleCloseFinalContractDialog}
        onSubmit={handleFinalContractSubmit}
        streetName={
          profileDetails?.PropertyDetails?.propertyAddress?.streetName
        }
        matchessm={matchessm}
        buyerId={WinnerBuyerId}
        userType={'Agent'}
        getListInfo={getListInfo}
        {...(user === 'vendor' && {
          isVendorContainer: true,
        })}
      />

      <PrepareContractSignDialog
        open={openPrepareDialog}
        onCancel={handleClosePrepareDialog}
        onSuccess={handleCloseAllContractDialogs}
        pdfFile={uploadedPdf}
        streetName={
          profileDetails?.PropertyDetails?.propertyAddress?.streetName
        }
        matchessm={matchessm}
        contractFileUrl={uploadedContractUrl}
        propertyId={params.dashboardId}
        buyerId={WinnerBuyerId}
        {...(user === 'vendor' && {
          vendorId: primaryOwner?.user?.userId,
          VendorContainer: true,
          signBuyerId: signBuyerId,
          propertyOwnerDetails:
            profileDetails?.PropertyDetails?.propertyOwnerDetails,
        })}
        userName={user == 'vendor' ? vendorFullName : winnerFullName}
      />

      {profileDetails && requestdeposit && (
        <Requestdeposit
          requestdeposit={requestdeposit}
          endPropertyPopupFromNominateWinner={
            endPropertyPopupFromNominateWinner
          }
          setRequestdeposit={setRequestdeposit}
          setReqDepositOpen={setReqDepositOpen}
          selectedrowbuyerid={selectedrowbuyerid}
          getListInfo={getListInfo}
          selectedrowbuyername={selectedrowbuyername}
          row={selectedrow}
          reqDepositOpen={reqDepositOpen}
          address={profileDetails?.PropertyDetails?.propertyAddress?.streetName}
          depositRes={depositRes}
          setEndPropertyPopupFromNominateWinner={
            setEndPropertyPopupFromNominateWinner
          }
          profileDetails={profileDetails}
          exchangeFlow={true}
        />
      )}
    </>
  );
}

ViewDashboardDetails.propTypes = {};

export default ViewDashboardDetails;
